import { StringParam, useQueryParams } from 'use-query-params'

import { useDidMountEffect, useQueryList } from '@percent/admin-dashboard/common/hooks'
import { useServices } from '@percent/admin-dashboard/containers/service/ServiceContext'
import { AutoApprovalListTable } from './autoApprovalListTable/AutoApprovalListTable'

export function AutoApprovalListContainer() {
  const { autoApprovalListService } = useServices()
  const [queryParams, setQueryParams] = useQueryParams({
    email: StringParam
  })

  const [{ totalResults, isLoading, dataOrNull, errorMessageOrNull }, { nextPage, previousPage, query, refresh }] =
    useQueryList(autoApprovalListService.getAutoApprovalList, {
      ...queryParams
    })

  useDidMountEffect(() => query(queryParams), [queryParams, query])

  return (
    <AutoApprovalListTable
      data={dataOrNull}
      isLoading={isLoading}
      errorMessage={errorMessageOrNull}
      nextPage={nextPage}
      previousPage={previousPage}
      totalResults={totalResults}
      queryParams={queryParams}
      setQueryParams={setQueryParams}
      refresh={refresh}
    />
  )
}
